import apiBase from "../../../api/axios";

const API_URL = "/v1/ranking/distribucion/";

export const getDistribucionTalentosService = async ({ escuela = null, plantel = null } = {}) => {
  let url = API_URL;
  const params = {};
  if (escuela !== null) params.escuela = escuela;
  if (plantel !== null) params.plantel = plantel;
  const response = await apiBase.get(url, { params });
  return response.data;
};
